/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLearningPath = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.707 1.293 20.414 5l-3.707 3.707-1.414-1.414L16.585 6H7a3 3 0 0 0-.176 5.995L7 12h10a5 5 0 0 1 .217 9.995L17 22H5v-2h12a3 3 0 0 0 .176-5.995L17 14H7a5 5 0 0 1-.217-9.995L7 4h9.585l-1.292-1.293z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLearningPath as LearningPath };
